export default __webpack_public_path__ + "static/to-down-b2f8381061e0bd0472249ebc476076f6.svg";